import { render, staticRenderFns } from "./platformOrderDetail.vue?vue&type=template&id=36d1370f&scoped=true"
import script from "./platformOrderDetail.vue?vue&type=script&lang=js"
export * from "./platformOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./platformOrderDetail.vue?vue&type=style&index=0&id=36d1370f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1370f",
  null
  
)

export default component.exports